import * as SentryBrowser from '@sentry/browser';
import { pick } from 'lodash';

const isOperaMini = () => {
  const { userAgent } = window.navigator;
  return userAgent.indexOf('Opera Mini') !== -1;
};

export const Sentry = SentryBrowser;
export const initSentry = () => {
  Sentry.init({
    beforeSend(event) {
      return isOperaMini() ? null : event;
    },
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    release: process.env.REACT_APP_VERSION || 'development',
    ignoreErrors: [
      /gtag/,
      /ValidationHandler/,
      /DoubleClickPrevention/,
      /duringWorkHours/ // this is a script issue on blokkendoos
    ],
    blacklistUrls: [
      /visualwebsiteoptimizer/,
      /blueconic/,
      /googletagmanager/,
      /hotjar/,
      /nxotexin.cf/
    ]
  });
};

export const getAxiosErrorData = ({ message, response, config }) => ({
  message,
  config,
  response: response && pick(response, ['data', 'headers', 'status'])
});
